function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing24, spacing48, grey5 } from "../../../../eden-style-constants";
import { Details } from "../../../../eden-details";
import { Text3 } from "../../../../eden-text";
const Wrapper = styled(Details).withConfig({
  componentId: "sc-58af31-0"
})(["border-block-end:1px solid ", ";"], grey5);
const Content = styled(Text3).withConfig({
  componentId: "sc-58af31-1"
})(["padding-inline-start:", ";padding-inline-end:", ";padding-block-end:", ";"], "0rem", "0rem", spacing48);

const Drawer = _ref => {
  let {
    open,
    onToggle,
    children,
    ...props
  } = _ref;
  const childrenArray = React.Children.toArray(children);
  const summary = childrenArray.shift();
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    as: Details,
    onToggle: onToggle,
    open: open
  }, props), summary, /*#__PURE__*/React.createElement(Content, null, childrenArray));
};

Drawer.propTypes = {
  /** Contents rendered inside the details. First child needs to be an `eden-drawer` `<Summary>` element. */
  children: PropTypes.node.isRequired,

  /** Whether details is open */
  open: PropTypes.bool,

  /** Handler called after a toggle occurs. Use `event.target.open` to get the current `open` state of the `Drawer`.  */
  onToggle: PropTypes.func
};
export default Drawer;